import { Box, Button, Paper, TextField, Typography, Grid, Accordion, AccordionSummary, AccordionDetails, List, ListItem, ListItemText, Card, FormControl, FormHelperText } from '@mui/material';
import { useEffect, useState } from 'react';
import { useSnackbar } from 'notistack';
import { useNavigate, useParams } from 'react-router-dom';
import configSiteUrls from '../../../configs/configSiteUrls';

import { useAddCentroApoioRespostaMutation, useGetCentroApoioByLoginMutation, useGetCentroApoioQuery } from '../centroApoioApiSlice';
import { IScentroApoio, IScentroApoioList, CentroApoioList, CentroApoioRespostaDTO } from '../types/CentroApoio';
import { Iso } from '@mui/icons-material';
import { CentroApoioAnexo } from '../types/CentroApoioAnexo';
import { useAddCentroApoioAnexosRespostaMutation, useGetCentroApoioAnexosQuery, useGetCentroApoioAnexosRespostaQuery, useRemoveCentroApoioAnexoExcluidoMutation } from '../centroApoioAnexoApiSlice';
import { GridExpandMoreIcon } from '@mui/x-data-grid';
import GeralAnexosUpload from '../../licitacao/create/GeralAnexosUpload';
import DownloadAnexoButton from '../../noticia/create/DownloadAnexoButton';
import convertImageToWeb from '../../../../../utils/convertImageToWeb';
import errorFormat from '../../../../../utils/errorFormat';
import { CentroApoioPainelDadoAtual } from './CentroApoioPainelDadoAtual';

export const CentroApoioEdit = () => {
  const { enqueueSnackbar } = useSnackbar();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const [dados, setDados] = useState<CentroApoioList>(IScentroApoioList);
  const [resposta, setResposta] = useState<string>('');

  //verificar se for edicao ele pega o id e faz a consulta
  const id = useParams().id || '';
  const { data, isFetching, error } = useGetCentroApoioQuery(id);
  useEffect(() => {
    if (data) {
      setDados(data as CentroApoioList);
      setResposta((data as CentroApoioList).resposta || '');
    }
  }, [data, error, isFetching]);

  const [createCentroApoioResposta, status] = useAddCentroApoioRespostaMutation();
  const [createAnexosResposta, statusCreateAnexosResposta] = useAddCentroApoioAnexosRespostaMutation();
  const [removeAnexosExcluidos, statusRemoveExcluido] = useRemoveCentroApoioAnexoExcluidoMutation();

  const [centroApoioAnexoParaSalvar, setCentroApoioAnexoParaSalvar] = useState<File[]>([]);
  const [centroApoioAnexoSalvo, setCentroApoioAnexoSalvo] = useState<CentroApoioAnexo[] | null>(null);

  const [centroApoioAnexoParaSalvarResposta, setCentroApoioAnexoParaSalvarResposta] = useState<File[]>([]);
  const [centroApoioAnexoSalvoResposta, setCentroApoioAnexoSalvoResposta] = useState<CentroApoioAnexo[] | null>(null);

  const handleFileAnexoChange = async (files: File[]) => {
    const convertedFiles = await Promise.all(files.map(file => convertImageToWeb(file)));
    setCentroApoioAnexoParaSalvarResposta(prev => [...prev, ...convertedFiles]);
  };
  const handleOnDeleteParaSalvarResposta = (index: number) => {
    setCentroApoioAnexoParaSalvarResposta(prev => prev.filter((_, i) => i !== index));
  };
  const handleExcluirTodosAnexos = () => {
    setCentroApoioAnexoParaSalvarResposta([]);
  };

  function handleOnDeleteSalvo(fileId: string) {
    setCentroApoioAnexoSalvoResposta(prev => {
      if (prev) {
        return prev.map(arq => (arq.id === fileId ? { ...arq, excluido: true } : arq));
      }
      return null; // ou um array vazio se preferir
    });
  }

  const { data: dataAnexo, isLoading: isLoadingAnexo } = useGetCentroApoioAnexosQuery({ idCentroApoioAnexo: dados.id ?? '' }, { skip: !dados.id });
  useEffect(() => {
    if (dataAnexo) {
      setCentroApoioAnexoSalvo(dataAnexo);
    }
  }, [dataAnexo]);

  const { data: dataAnexoResposta, isLoading: isLoadingAnexoResposta } = useGetCentroApoioAnexosRespostaQuery({ idCentroApoioAnexo: dados.id ?? '' }, { skip: !dados.id });
  useEffect(() => {
    if (dataAnexoResposta) {
      setCentroApoioAnexoSalvoResposta(dataAnexoResposta);
    }
  }, [dataAnexoResposta]);

  async function handleSubmit(e: React.FormEvent<HTMLFormElement>) {
    e.preventDefault();
    if (!resposta || resposta.trim() === '') {
      enqueueSnackbar('O campo Resposta é obrigatório.', { variant: 'warning' });
      return;
    }

    const parms: CentroApoioRespostaDTO = {
      id: dados.id || '',
      resposta: resposta.trim()
    };

    setLoading(true);
    const result: any = await createCentroApoioResposta(parms);
    const dataCentroApoio = result?.data;
    const idCentroApoio = dataCentroApoio?.id;

    if (idCentroApoio) {
      if (centroApoioAnexoParaSalvarResposta.length) {
        const formData = new FormData();
        centroApoioAnexoParaSalvarResposta.forEach(file => formData.append('imagens', file));
        formData.append('centroApoioID', idCentroApoio);
        createAnexosResposta(formData);
      }

      if (centroApoioAnexoSalvoResposta && centroApoioAnexoSalvoResposta?.length) {
        let centroApoioAnexoSalvoExcluido: { idAnexo: string }[];

        centroApoioAnexoSalvoExcluido = centroApoioAnexoSalvoResposta.filter(it => it.excluido === true).map(it => ({ idAnexo: it.id }));

        if (centroApoioAnexoSalvoExcluido.length) {
          const formData = new FormData();
          formData.append('centroApoioID', idCentroApoio);
          formData.append('anexosExcluidos', JSON.stringify(centroApoioAnexoSalvoExcluido));
          removeAnexosExcluidos(formData);
        }
      }

      handleExcluirTodosAnexos();
      //navigate(configSiteUrls.SITE_CENTRO_APOIO_T);
    }
    setLoading(false);
  }
  useEffect(() => {
    if (status.isError) {
      enqueueSnackbar('Registro não incluído!', { variant: 'error' });
      const erroReturn: string = errorFormat(status);
      enqueueSnackbar(erroReturn, { variant: 'error' });
    }

    if (status.isSuccess) {
      enqueueSnackbar('Registro incluído!', { variant: 'success' });
      // navigate(-1);
      // setGrupo(ISgrupo);
    }
  }, [status]);

  return (
    <Box sx={{ mt: 4, display: 'flex', justifyContent: 'center' }}>
      <Paper
        sx={{
          width: '100%',
          p: 3,
          mx: 'auto',
          maxWidth: {
            xs: '100%', // celular
            sm: '600px', // tablets
            md: '800px', // telas médias
            lg: '1000px', // telas grandes
            xl: '1200px' // monitores muito grandes
          }
        }}
      >
        {!dados.id ? (
          <>
            <Typography variant="body1" sx={{ mb: 2 }}>
              A solicitação que você está tentando acessar não foi encontrada. Verifique se o link está correto ou entre em contato com o suporte para obter assistência.
            </Typography>
          </>
        ) : (
          <>
            <CentroApoioPainelDadoAtual dados={dados} centroApoioAnexoSalvo={centroApoioAnexoSalvo} isLoadingAnexo={isLoadingAnexo} />

           

              <Typography color="secondary" sx={{ mt:5, fontWeight: 'bold' }} variant="body1" gutterBottom>
                Dados da Resposta
              </Typography>

            <Card
              elevation={3}
              sx={{
                p: 3,
                borderRadius: 3,
                bgcolor: '#fafafa',
                mb: 3
              }}
            >
              <form onSubmit={handleSubmit} method="POST">
                <Grid container spacing={2}>
                  {/* Observação */}
                  <Grid item xs={12}>
                    <FormControl fullWidth>
                      <TextField
                        required
                        label="Resposta"
                        name="resposta"
                        onChange={e => setResposta(e.target.value)}
                        size="small"
                        multiline
                        rows={4}
                        inputProps={{ maxLength: 5000 }}
                        value={resposta}
                      />
                      <FormHelperText>{resposta?.length}/5000 caracteres</FormHelperText>
                    </FormControl>
                  </Grid>
                </Grid>
                <Grid item xs={12}>
                  <Box>
                    <Accordion defaultExpanded={false}>
                      <AccordionSummary expandIcon={<GridExpandMoreIcon />} aria-controls="panel2-content" id="panel4-header">
                        <Typography color="secondary" variant="body1" gutterBottom>
                          Anexos
                        </Typography>
                      </AccordionSummary>

                      <AccordionDetails>
                        <Paper>
                          <GeralAnexosUpload
                            arquivosSalvos={centroApoioAnexoSalvoResposta ?? null}
                            arquivosParaSalvar={centroApoioAnexoParaSalvarResposta}
                            onFileChange={handleFileAnexoChange}
                            onDeleteParaSalvar={handleOnDeleteParaSalvarResposta}
                            onDeleteAll={handleExcluirTodosAnexos}
                            onDeleteSalvo={handleOnDeleteSalvo}
                            tipo="CENTRO_APOIO"
                          />
                        </Paper>
                      </AccordionDetails>
                    </Accordion>
                  </Box>
                </Grid>
                <Grid item xs={12}>
                  <Button type="submit" sx={{ mt: 3, ml: 2 }} variant="contained" color="secondary">
                    Gravar Resposta
                  </Button>

                  <Button variant="outlined" sx={{ mt: 3, ml: 2 }} onClick={() => navigate(configSiteUrls.SITE_CENTRO_APOIO_LIST)}>
                    Voltar
                  </Button>
                </Grid>
              </form>
            </Card>
          </>
        )}
      </Paper>
    </Box>
  );
};
